<template>
  <div class="chat animated fadeIn">
    <ChatSidebar />

    <div
      :class="{ 'chat__content--dragging': isDragging }"
      class="chat__content position-relative d-flex flex-column flex-grow-1"
      @dragover.prevent
      @dragenter.prevent="isDragging = true"
      @dragleave.prevent.self="isDragging = false"
      @drop.prevent="onDrop"
      @click="isDragging = false"
    >
      <div v-if="showDropzone" class="chat__dropzone">
        <div class="text-center font-xl">
          <div class="font-6xl">
            <i class="icon-docs" />
          </div>
          <div>Drop files here</div>
        </div>
      </div>

      <ChatTopbar v-if="selectedId" />

      <ChatIconText v-if="isAdmin" icon="ban">
        You do not have permission to view chat
      </ChatIconText>

      <ChatIconText v-else-if="!selectedId">
        Select a chat or create a new one
      </ChatIconText>

      <ChatMessages v-else ref="messages" />

      <ChatMessageInput ref="input" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ChatIconText from "@/components/chat/ChatIconText";
import ChatMessageInput from "@/components/chat/ChatMessageInput";
import ChatMessages from "@/components/chat/ChatMessages";
import ChatSidebar from "@/components/chat/ChatSidebar";
import ChatTopbar from "@/components/chat/ChatTopbar";

export default {
  components: {
    ChatIconText,
    ChatMessageInput,
    ChatMessages,
    ChatSidebar,
    ChatTopbar
  },

  data: () => ({
    isDragging: false
  }),

  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapGetters("contacts", ["getNickname"]),
    ...mapGetters("chat", ["selectedGroup"]),
    ...mapState("chat", ["selectedId"]),
    ...mapState(["user"]),

    showDropzone() {
      return this.isDragging && this.selectedId;
    }
  },

  async mounted() {
    if (this.isAdmin) return;
    this.connect();
    this.getAttachmentConfig();
    this.getContacts();
  },

  methods: {
    ...mapActions("contacts", ["getContacts"]),
    ...mapActions("chat", ["connect", "getAttachmentConfig"]),

    onDrop(e) {
      this.isDragging = false;
      if (!this.selectedId) return;

      if (!e.dataTransfer.files.length) return;
      this.$refs.input.onDrop(e);
    }
  }
};
</script>

<style lang="scss">
.chat {
  display: flex;
  align-items: stretch;
  height: 100%;

  &__content--dragging > * {
    pointer-events: none;
  }

  &__dropzone {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    background: rgba(255, 255, 255, 0.75);
  }
}
</style>
